import { REDUCERS } from '@/constants/reducers';

export function favoritos(state, action) {
    const current = state.favoritos || { items: [], isLoading: false };
    switch (action.type) {
        case REDUCERS.UPDATE_FAVORITOS:
            return { ...state, favoritos: { ...current, ...action.payload } };
        default:
            return state;
    }
}
